module.exports = __webpack_public_path__ + "static/img/3.7b85d8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/zh/3.png
// module id = Sf/G
// module chunks = 0